import type { AdminViewDefinition } from "../../components/admin-components.js";

export const usageAdminViews: AdminViewDefinition[] = [usageOverviewView()];

function usageOverviewView(): AdminViewDefinition {
  return {
    id: "usage-overview",
    navId: "usage",
    title: "Usage & Cost Overview",
    description:
      "Monitor live aggregate request, extraction, notification, and provider-unit totals.",
    actions: [
      {
        label: "Last 30 days",
        disabled: true,
        disabledReason: "Usage date-range controls are not wired yet.",
      },
      {
        label: "Usage detail",
        routeId: "usage-detail",
        disabled: true,
        disabledReason: "Usage detail does not have a backend API yet.",
      },
    ],
  };
}
